// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"34138850","859":"4199b8ee"}[chunkId] + ".chunk.js";
};